import { Button } from "@mui/material"
import { trans } from "@/_providers/Translation"
import Dropdown from "@/components/partials/Dropdown"
import { useRef } from "react"
import removeImage from "@/assets/img/reservations/icons/remove.svg"

export default function SubscriptionDevice({
  device,
  index,
  onUpdateField,
  onRemove,
  validations,
}) {
  const inputModelsRef = useRef(null)

  const handleApplianceChange = (data) => {
    onUpdateField(index, "appliancecategory", data)
    onUpdateField(index, "appliancebrand", {})
    onUpdateField(index, "appliancemodel", {})

    if (inputModelsRef.current) {
      inputModelsRef.current.reset()
    }
  }

  const handleBrandChange = (data) => {
    onUpdateField(index, "appliancebrand", data)
    onUpdateField(index, "appliancemodel", {})

    if (inputModelsRef.current) {
      inputModelsRef.current.reset()
    }
  }

  const handleModelChange = (data) => {
    onUpdateField(index, "appliancemodel", data)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    // Extract field name from appliances[index][field_name] format
    const fieldName = name.match(/\[([^\]]+)\]$/)?.[1] || name
    onUpdateField(index, fieldName, value)
  }

  return (
    <div className="device-container">
      <div className="head">
        {`Уред ${index + 1}`}
        {onRemove && (
          <Button
            onClick={(e) => {
              e.stopPropagation()
              onRemove(index)
            }}
          >
            <img src={removeImage} alt="Remove" />
          </Button>
        )}
      </div>
      {console.log({
        category_id:
          device?.category && device?.category?.id
            ? Number(device?.category?.id)
            : null,
        brand_id:
          device?.brand && device?.brand?.id ? Number(device?.brand?.id) : null,
      })}
      {console.log(device)}
      <div className="body">
        <div className="row">
          <div className="col">
            <label>{trans("labels.category")}</label>
            <Dropdown
              inputName=""
              inputValue={
                device?.category?.name || device?.appliancecategory?.name || ""
              }
              inputIdName={`appliances[${index}][appliance_category_id]`}
              inputIdValue={
                device?.category?.id || device?.appliancecategory?.id || ""
              }
              url="partners/categories/all"
              params={{
                id:
                  device?.category?.id || device?.appliancecategory?.id || null,
              }}
              inputClassName={
                validations &&
                validations[`appliances.${index}.appliance_category_id`]
                  ? "validate"
                  : ""
              }
              onChange={handleApplianceChange}
            />
          </div>
          <div className="col">
            <label>{trans("labels.make")}</label>
            <Dropdown
              inputName=""
              inputValue={
                device?.brand?.name || device?.appliancebrand?.name || ""
              }
              inputIdName={`appliances[${index}][appliance_brand_id]`}
              inputIdValue={
                device?.brand?.id || device?.appliancebrand?.id || ""
              }
              url="partners/brands/all"
              params={{
                id: device?.brand?.id || device?.appliancebrand?.id || null,
              }}
              inputClassName={
                validations &&
                validations[`appliances.${index}.appliance_brand_id`]
                  ? "validate"
                  : ""
              }
              onChange={handleBrandChange}
            />
          </div>
          <div className="col">
            <label>{trans("labels.model")}</label>
            {console.log(device)}
            {console.log(device?.model)}
            <Dropdown
              ref={inputModelsRef}
              inputName="appliance_model"
              inputIdName={`appliances[${index}][appliance_model_id]`}
              inputValue={
                device?.model?.name
                  ? device?.model?.name
                  : device?.appliancemodel?.name || ""
              }
              inputIdValue={
                device?.model?.id
                  ? device?.model?.id
                  : device?.appliancemodel?.id || ""
              }
              inputClassName={
                validations &&
                validations[`appliances.${index}.appliance_model_id`]
                  ? "validate"
                  : ""
              }
              url="appliances/models/all"
              params={{
                category_id: device?.category?.id
                  ? Number(device?.category?.id)
                  : device?.appliancecategory?.id
                    ? Number(device?.appliancecategory?.id)
                    : null,
                brand_id: device?.brand?.id
                  ? Number(device?.brand?.id)
                  : device?.appliancebrand?.id
                    ? Number(device?.appliancebrand?.id)
                    : null,
              }}
              requiredParams={["category_id", "brand_id"]}
              onChange={handleModelChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label>{trans("labels.serialNo")}</label>
            <input
              value={device && device.serial_no ? device.serial_no : ""}
              type="text"
              name={`appliances[${index}][serial_no]`}
              onChange={handleInputChange}
            />
          </div>
          <div className="col">
            <label>{trans("labels.productCode")}</label>
            <input
              type="text"
              name={`appliances[${index}][product_code]`}
              value={device && device.product_code ? device.product_code : ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {device.id ? (
          <input
            type="hidden"
            name={`appliances[${index}][id]`}
            value={device.id}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
